module.exports = __webpack_public_path__ + "img/reward_400.38c63b87.png";